module.exports = __webpack_public_path__ + "static/media/nftsingle-bg.40148ed2.png";